import initialState from './initialState'

const SET_ARRAY_PAYMENTS = (state, arrayPayments) =>
    (state.arrayPayments = arrayPayments)

const setPaymentAmount = function(state, payload) {
    // state.iva = 0 //no se usan
    // state.net_total = 0 //no se usan
    let data = [...payload]
    console.log('CALC', payload)
    state.total = data
        .map(
            payload => payload.receivable
            //payload.account_receivable && payload.account_receivable.balance
            //? payload.account_receivable.balance
            //: payload.total
        )
        .reduce(
            (accumulator, amountInvoice) => (accumulator += amountInvoice),
            0
        )
}

const SET_PAYMENT_METHOD = function(status, id) {
    status.paymentMethod = id
}

const SAVE_PAYMENT = function(state) {
    if (state.paymentMethod === 1) {
        // If current payment is cash payment

        let posCashPayment = searchCashPayment(state) // First we ask if a cash payment has already made

        if (posCashPayment != -1) {
            // If a cash payment has been made, current payment is added
            let acum =
                parseInt(state.arrayPayments[posCashPayment].payment) +
                parseInt(state.payment)
            state.arrayPayments[posCashPayment].payment = acum.toString()
            state.lastPaymentMethod = state.paymentMethod // Last payment method is updated
            return
        }
    }
    // In any other case, current payment is pushed to arrayPayments
    state.arrayPayments.push({
        payment: state.payment, // Amount of payment
        paymentMethod: state.paymentMethod,
        paymentDetail: state.paymentDetail,
    })
    state.lastPaymentMethod = state.paymentMethod // Last payment method is updated
}

const searchCashPayment = function(state) {
    var i
    for (i = 0; i < state.arrayPayments.length; i++) {
        if (state.arrayPayments[i].paymentMethod === 1) {
            // If cash payment is found, returns it's position in the array
            return i
        }
    }
    return -1
}

const CLEAR_INVOICES_SELECTED = function(state) {
    state.invoiceSelected = []
}

const CLEAR_PAYMENT = function(state) {
    state.payment = ''
    state.paymentDetail = null
}

const CLEAR_ARRAY_PAYMENTS = function(state) {
    state.arrayPayments = []
}

const SET_PAYMENT = function(state, paymentPayLoad) {
    state.payment = paymentPayLoad
}

const SET_INVOICE = function(state, invoiceInfo) {
    state.invoiceSelected = invoiceInfo
}

const SET_PAYMENT_DETAIL = function(state, plPaymentDetail) {
    state.paymentDetail = plPaymentDetail
}

const SET_BANKS = function(state, banks) {
    state.banks.length = 0
    for (let i = 0; i < banks.data.length; i++) {
        state.banks.push(banks.data[i])
    }
}

const SET_STEP = function(state, step) {
    state.currentStep = step
}

const RESET_STATE = function(state) {
    Object.assign(state, initialState())
}

export default {
    setPaymentAmount,
    SET_PAYMENT_METHOD,
    SAVE_PAYMENT,
    CLEAR_INVOICES_SELECTED,
    CLEAR_PAYMENT,
    SET_PAYMENT,
    SET_INVOICE,
    SET_PAYMENT_DETAIL,
    SET_BANKS,
    SET_STEP,
    CLEAR_ARRAY_PAYMENTS,
    SET_ARRAY_PAYMENTS,
    RESET_STATE,
}
